enum BiteLogVerifonePointCloudEvent {
  TerminalDisconnected = 5,
}

export { BiteLogVerifonePointCloudEvent };
